import BillSwitchSweepstakesScreen from 'features/billSwitch/screens/BillSwitchSweepstakesScreen/BillSwitchSweepstakesScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function BillSwitchPhoneBillPage() {
  return (
    <PinwheelContextProvider>
      <BillSwitchSweepstakesScreen />
    </PinwheelContextProvider>
  );
}
